import React, { useEffect, useState, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FrameOne from './FrameOne';
import FrameTwo from './FrameTwo';
import FrameThree from './FrameThree';
import FrameFour from './FrameFour';
import FrameFive from './FrameFive';
import { useHistory } from 'react-router';
import { NAICS_LIST, PSC_LIST } from '../../constans';
import { businessRegistrationPost, userGet } from '../../api';
import { oneSelectNotice } from '../UI/Notifications';
import Loading from '../Loading';
import { UserContext } from '../../context/User';

const BusinessRegistration = () => {
  const { setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [frame, setFrame] = useState("frame_one");
  const history = useHistory();
  const [inputValue, setInputValue] = useState({
    type: "",
    naics: "",
    payment_method: "",
    set_aside: "",
    keywords: "",
    psc_code: ""
  })
  const [selectValue, setSelectValue] = useState([]);
  const [step, setStep] = useState(2);
  const [filledData, setFilledData] = useState({});
  const [list, setList] = useState([]);
  const [sendRequest, setSendRequest] = useState(false);
  const [terms, setTerms] = useState(false);
  const [searchTrigger, setSearchTrigger] = useState(false);

  const handleMultiDelete = (name, valuesFunc, valuesValue) => {
    switch (name.action) {
      case 'remove-value':
        valuesFunc([...valuesValue.filter(el => el.value !== name.removedValue.value)]);
        break;
      case 'clear':
        valuesFunc([...valuesValue.filter(el => el.type !== name.name)]);
        break;
      default:  
    }
  }

  const handleMultiAdd = (item, valuesFunc, valuesValue) => {
    switch (item.type) {
      case 'type':
      case 'naics':
      case 'payment_method':
      case 'set_aside':
      case 'psc_code':
        valuesFunc([...valuesValue, item]);
        break;
      default:
        valuesFunc([...valuesValue.filter(i => i.type !== item.type), item]);
    }
  }

  const setLimitSelectValues = (data, value, blackList = null) => {
    let i = 0;

    if (blackList === null) blackList = [];

    const newList = data.filter(item => {
      if (item.label.toLowerCase().includes(value.toLowerCase()) && i < 10) {
        if (!blackList.includes(item.value)) i++;
        return item
      }
    })

    setList(newList);
  }

  const onChangeHandler = (value, name) => {
    if (name === 'naics') setLimitSelectValues(NAICS_LIST, value);
    if (name === 'psc_code') setLimitSelectValues(PSC_LIST, value);

    setInputValue({
      ...inputValue,
      [name]: value
    })

    if (!value) setList([]);
  }

  const handleMultiChange = (event, name) => {
    const item = Array.isArray(event) ? event[event.length - 1] : "";
    
    if (name.removedValue || name.removedValues) {
      handleMultiDelete(name, setSelectValue, selectValue); 
    } else if (item) {
      handleMultiAdd(item, setSelectValue, selectValue); 
    } else if (event && event.type) {
      setSelectValue([...selectValue, event]);
    }

    setInputValue({ ...inputValue, search: "" });
  }

  const frameSwitch = () => {
    switch (frame) {
      case "frame_one":
        setStep(3);
        setFrame("frame_two");
        break;
      case "frame_two":
        setStep(4);
        setFrame("frame_three");
        break;
      case 'frame_three':
        setStep(5);
        setFrame("frame_four");
        break;
      case 'frame_four':
        setStep(6);
        setFrame("frame_five");
        break;
      default:
    }
  }

  useEffect(() => sendRequest && registerBusinessRequest(), [searchTrigger])

  const registerBusinessRequest = () => {
    setLoading(true)
    const params = {...filledData};

    for (let prop in params) {
      if (params[prop] === null || params[prop] === undefined || params[prop] === "" || params[prop].length === 0) {
        delete params[prop];
      }

      if (params[prop] === 'false') {
        params[prop] = false
      } else if (params[prop] === 'true') {
        params[prop] = true
      }

      if (params[prop] && prop === "keywords") {
        params[prop] = params[prop].split(',').map(item => item.trim());
      }
    }

    if ("payment_method" in params) {
      businessRegistrationPost(params) 
      .then(response => {
        setLoading(false);
        userGet()
          .then(response => {
            setUser(response.data);
            setLoading(false);
            history.push('/dashboard');
          })
          .catch(error => {
            
          })
      })
      .catch(error => {
        setLoading(false);
      })
    } else {
      setLoading(false);
      oneSelectNotice("You need to choose at least one payment method");
    }
  }

  const onSubmit = (data = null, e = null) => {
    const obj = {
      type: [],
      naics: [],
      payment_method: [],
      set_aside: [],
      psc_code: []
    };

    selectValue.forEach((item) => {
      obj[item.type].push(item.value);
    })

    setFilledData({...filledData, ...data, ...obj});
    frameSwitch();

    if (frame === "frame_five") {
      setSendRequest(true);
      setSearchTrigger(!searchTrigger);
    }
  }

  const onChange = e => {
    const value = e.target.value;
    const name = e.target.name;

    setInputValue({
      ...inputValue,
      [name]: value
    })
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col lg={{ span: 8, offset: 1 }}>
            <div className="step-header">
              <h2>Business Information</h2>
              <div className="step-container">
                <p>
                  Step <span>{step}</span> of 6
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          {
            frame === "frame_one" && (
              <Col lg={{ span: 6, offset: 1 }}>
                <FrameOne 
                  onSubmit={onSubmit} 
                />
              </Col>
            )
          }
          {
            frame === "frame_two" && (
              <Col lg={{ span: 6, offset: 1 }}>
                <FrameTwo 
                  onSubmit={onSubmit} 
                  inputValue={inputValue}
                  onChangeHandler={onChangeHandler}
                  handleMultiChange={handleMultiChange}
                  selectValue={selectValue}
                  onChange={onChange}
                  list={list}
                />
              </Col>
            )
          }
          {
            frame === "frame_three" && (
              <Col lg={{ span: 10, offset: 1 }}>
                <FrameThree 
                  onSubmit={onSubmit}
                  inputValue={inputValue}
                  selectValue={selectValue}
                />
              </Col>
            )
          }
          {
            frame === "frame_four" && (
              <Col lg={{ span: 6, offset: 1 }}>
                <FrameFour
                  onSubmit={onSubmit} 
                />
              </Col>
            )
          }
          {
            frame === "frame_five" && (
              <Col lg={{ span: 6, offset: 1 }}>
                <FrameFive
                  onSubmit={onSubmit} 
                  inputValue={inputValue}
                  onChangeHandler={onChangeHandler}
                  handleMultiChange={handleMultiChange}
                  selectValue={selectValue}
                  setTerms={setTerms}
                  terms={terms}
                />
              </Col>
            )
          }
        </Row>
        {loading && <Loading />}
      </Container>
    </section>
  )
}

export default BusinessRegistration;